export default {
  "reset-password.title": "Reset password",
  "reset-password.success.message": "Password was successfully updated",
  "reset-password.success.description": "Please log in again",
  "reset-password.new-password": "New password",
  "reset-password.new-password-repeat": "Repeat new password",
  "reset-password.required-field": "Please fill in all indicated fields",
};
